import { render, staticRenderFns } from "./treeView.vue?vue&type=template&id=204b60fd&scoped=true&"
import script from "./treeView.vue?vue&type=script&lang=js&"
export * from "./treeView.vue?vue&type=script&lang=js&"
import style0 from "./treeView.vue?vue&type=style&index=0&id=204b60fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b60fd",
  null
  
)

export default component.exports